<template>
  <aside id="app-sidebar" class="app-sidebar">
    <div class="sidebar-content">
      <!-- Audi Logo -->
      <div class="logo-container">
        <div class="audi-logo">
          <svg class="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 130 45">
            <g id="Audi Rings">
              <path d="M107.178 39.964C103.193 39.964 99.5207 38.6105 96.5838 36.3416C99.5642 32.5215 101.348 27.7173 101.348 22.5C101.348 17.2831 99.5642 12.4789 96.5838 8.65845C99.5207 6.39 103.193 5.03595 107.178 5.03595C116.774 5.03595 124.581 12.8704 124.581 22.5C124.581 32.13 116.774 39.964 107.178 39.964ZM68.3315 36.3416C71.3123 32.5215 73.0962 27.7173 73.0962 22.5C73.0962 17.2831 71.3123 12.4789 68.3319 8.65845C71.2683 6.39 74.942 5.03595 78.926 5.03595C82.9104 5.03595 86.5831 6.39 89.52 8.65845C86.5396 12.4789 84.7557 17.2831 84.7557 22.5C84.7557 27.7173 86.5396 32.5215 89.52 36.3416C86.5831 38.6105 82.9104 39.964 78.926 39.964C74.942 39.964 71.2683 38.6105 68.3315 36.3416ZM40.0796 36.3416C43.0604 32.5215 44.8443 27.7173 44.8443 22.5C44.8443 17.2831 43.0604 12.4789 40.08 8.65845C43.0164 6.39 46.6901 5.03595 50.674 5.03595C54.658 5.03595 58.3317 6.39 61.2681 8.65845C58.2877 12.4789 56.5038 17.2831 56.5038 22.5C56.5038 27.7173 58.2877 32.5215 61.2681 36.3416C58.3317 38.6105 54.658 39.964 50.674 39.964C46.6901 39.964 43.0164 38.6105 40.0796 36.3416ZM5.01852 22.5C5.01852 12.8704 12.8259 5.03595 22.4221 5.03595C26.4061 5.03595 30.0798 6.39 33.0162 8.65845C30.0358 12.4789 28.2519 17.2831 28.2519 22.5C28.2519 27.7173 30.0358 32.5215 33.0162 36.3416C30.0798 38.6105 26.4061 39.964 22.4221 39.964C12.8259 39.964 5.01852 32.13 5.01852 22.5ZM36.5481 32.6821C34.4884 29.8134 33.2704 26.298 33.2704 22.5C33.2704 18.7024 34.4884 15.1866 36.5481 12.3178C38.6078 15.1866 39.8258 18.7024 39.8258 22.5C39.8258 26.298 38.6078 29.8134 36.5481 32.6821ZM64.8 32.6821C62.7403 29.8134 61.5223 26.298 61.5223 22.5C61.5223 18.7024 62.7403 15.1866 64.8 12.3178C66.8597 15.1866 68.0777 18.7024 68.0777 22.5C68.0777 26.298 66.8597 29.8134 64.8 32.6821ZM93.0519 32.6821C90.9922 29.8134 89.7742 26.298 89.7742 22.5C89.7742 18.7024 90.9922 15.1866 93.0519 12.3178C95.1116 15.1866 96.3296 18.7024 96.3296 22.5C96.3296 26.298 95.1116 29.8134 93.0519 32.6821ZM107.178 0C101.827 0 96.9103 1.89315 93.0519 5.04315C89.1935 1.89315 84.2768 0 78.926 0C73.5751 0 68.6584 1.89315 64.8 5.04315C60.9416 1.89315 56.0244 0 50.674 0C45.3232 0 40.4065 1.89315 36.5481 5.04315C32.6897 1.89315 27.7725 0 22.4221 0C10.0586 0 0 10.0935 0 22.5C0 34.9069 10.0586 45 22.4221 45C27.7725 45 32.6897 43.1073 36.5481 39.9568C40.4065 43.1073 45.3232 45 50.674 45C56.0244 45 60.9416 43.1073 64.8 39.9568C68.6584 43.1073 73.5751 45 78.926 45C84.2768 45 89.1935 43.1073 93.0519 39.9568C96.9103 43.1073 101.827 45 107.178 45C119.541 45 129.6 34.9069 129.6 22.5C129.6 10.0935 119.541 0 107.178 0Z" fill="white"></path>
            </g>
          </svg>
        </div>
      </div>

      <!-- Navigation -->
      <div class="navigation">
        <div class="nav-title">Dashboard</div>

       <b-navbar-nav class="nav flex-column nav-items">
          <div class="nav-item"
                :class="{ active: isActiveRoute('/marketreports') }"
                @click="navigate('/marketreports', 'Überblick')">
            <span class="material-symbols-outlined">dashboard</span>
            <span class="nav-text">Überblick</span>
          </div>

          <div  class="nav-item"
                :class="{ active: isActiveRoute('/wizard') }"
                @click="navigate('/wizard', 'Wizard')">
            <span class="material-symbols-outlined">auto_fix_high</span>
            <span class="nav-text">Wizard</span>
          </div>

          <div  class="nav-item"
                :class="{ active: isActiveRoute('/clientmanagement') }"
                v-if="globals.isAccessAllowed('LoopOp_Clients_ReadAll') && !globals.currentUserInfo.IsAudiUser"
                @click="navigate('/clientmanagement', lang.A0000)">
            <span class="material-symbols-outlined">contacts_product</span>
            <span class="nav-text">{{ lang.A0000 }}</span>
          </div>

          <div  class="nav-item"
                :class="{ active: isActiveRoute('/locationmanagement') }"
                v-if="globals.isAccessAllowed('LoopOp_Locations_ReadAll')"
                @click="navigate('/locationmanagement', lang.A0001)">
            <span class="material-symbols-outlined">location_on</span>
            <span class="nav-text">{{ lang.A0001 }}</span>
          </div>

          <div  class="nav-item"
                :class="{ active: isActiveRoute('/usermanagement') }"
                @click="navigate('/usermanagement', lang.A0010)"
                v-if="globals.isAccessAllowed('LoopOp_SecurityUsers_ReadAll')">
            <span class="material-symbols-outlined">group</span>
            <span class="nav-text">{{ lang.A0010 }}</span>
          </div>

          <div  class="nav-item"
                :class="{ active: isActiveRoute('/projectmanagement') }"
                @click="navigate('/projectmanagement', lang.A0011)"
                v-if="globals.isAccessAllowed('LoopOp_Projects_ReadAll')">
            <span class="material-symbols-outlined">folder_open</span>
            <span class="nav-text">{{ lang.A0011 }}</span>
          </div>

          <div  class="nav-item"
                :class="{ active: isActiveRoute('/agencymanagement') }"
                v-if="globals.isAccessAllowed('LoopOp_Agencies_ReadAll') && !globals.isLocalAgencyUser"
                @click="navigate('/agencymanagement', lang.A0012)">
            <span class="material-symbols-outlined">business</span>
            <span class="nav-text">{{ lang.A0012 }}</span>
          </div>

          <div  class="nav-item"
                :class="{ active: isActiveRoute('/surveymanagement') }"
                v-if="globals.isAccessAllowed('LoopOp_Surveys_ReadAll')"
                @click="navigate('/surveymanagement', lang.A0013)">
            <span class="material-symbols-outlined">quiz</span>
            <span class="nav-text">{{ lang.A0013 }}</span>
          </div>

          <div  class="nav-item"
                :class="{ active: isActiveRoute('/checkmanagement') }"
                v-if="globals.isAccessAllowed('LoopOp_SurveyInstances_ReadAll') && globals.currentUserRole < 3"
                @click="navigate('/checkmanagement', lang.A0014)">
            <span class="material-symbols-outlined">checklist</span>
            <span class="nav-text">{{ lang.A0014 }}</span>
          </div>

          <div  class="nav-item"
                :class="{ active: isActiveRoute('/kpimanagement') }"
                v-if="globals.isAccessAllowed('LoopOp_KPIs_ReadAll')"
                @click="navigate('/kpimanagement', lang.A0016)">
            <span class="material-symbols-outlined">analytics</span>
            <span class="nav-text">{{ lang.A0016 }}</span>
          </div>

          <div  class="nav-item"
                :class="{ active: isActiveRoute('/shoppermanagement') }"
                v-if="
                  feature.isEnabled('shoppermanagement') &&
                  globals.isAccessAllowed('LoopOp_Shopper_ReadAll') &&
                  !(
                    feature.isAudiTarget &&
                    (globals.isLeadAgencyUser || globals.isAudiUser)
                  )
                "
                @click="navigate('/shoppermanagement', lang.A0023)">
            <span class="material-symbols-outlined">person_check</span>
            <span class="nav-text">{{ lang.A0023 }}</span>
          </div>

          <div  class="nav-item"
                :class="{ active: isActiveRoute('/recruiting') }"
                v-if="
                  feature.isEnabled('recruiting') &&
                  globals.isAccessAllowed('LoopOp_Recruiting_ReadAll')
                "
                @click="navigate('/recruiting', lang.A0029)">
            <span class="material-symbols-outlined">person_search</span>
            <span class="nav-text">{{ lang.A0029 }}</span>
          </div>

          <div  class="nav-item"
                :class="{ active: isActiveRoute('/shopperapproval') }"
                v-if="feature.isEnabled('shopperApproval') && globals.currentUserInfo"
                @click="navigate('/shopperapproval', lang.A0032)">
            <span class="material-symbols-outlined">task_alt</span>
            <span class="nav-text">{{ lang.A0032 }}</span>
          </div>
        </b-navbar-nav>
      </div>
    </div>
  </aside>
</template>


<script>

export default {
  data() {
    return {
      showGuide: false,
    };
  },

  props: {
    lang: { type: Object, required: true }
  },

  methods: {
    navigate(route, title) {
      this.$router.push(route);
      this.$emit('set-title', title);
    },

    hasClass(element) {
      return element.classList;
    },

    logout() {
      // AuthenticationService.logout();
      if (this.isExternalUser)
        this.$router.push({ name: 'signedout' })
    },

    isActiveRoute(route) {
      return this.$route.path === route || this.$route.path.startsWith(route + '/');
    },
  },

  computed: {
    localUserProfile() {
      return this.globals.currentUserInfo;
    },

    userDisplayName: function() {
      return `${this.localUserProfile.FirstName} ${this.localUserProfile.LastName}`;
    },

    userInitials: function() {
      if (this.localUserProfile.FirstName && this.localUserProfile.LastName)
        return this.localUserProfile.FirstName.charAt(0).toUpperCase() + this.localUserProfile.LastName.charAt(0).toUpperCase();
      else
        return '';
    }
  },
};
</script>


<style lang="css" scoped>
.app-sidebar {
  background-color: #000000;
  width: 242px;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  padding: 49px 0;
}

.sidebar-content {
  display: flex;
  flex-direction: column;
  gap: 64px;
  height: 100%;
  align-items: center;
  justify-content: flex-start;
}

.logo-container {
  .audi-logo {
    width: 129.6px;
    height: 45px;
    transition: transform 0.2s;

    &:hover {
      transform: scale(1.05);
    }
  }
}

.navigation {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 177px;
}

.nav-title {
  font-weight: 600;
  color: #ffffff;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.002px;
  text-align: left;
}

.nav-items {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.nav-item {
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  padding: 10px 16px;
  cursor: pointer;
  transition: all 0.2s;
  color: white;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    border-left: 4px solid #f50537;

    .material-symbols-outlined {
      transform: scale(1.1);
    }
  }

  &.active {
    background-color: #f50537;
    border-left: 4px solid white;
  }

  .material-symbols-outlined {
    font-size: 20px;
    transition: transform 0.2s;
    font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 20;
  }

  .nav-text {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    white-space: nowrap;
  }
}

@media (max-width: 1024px) {
  .app-sidebar {
    width: 64px;

    .nav-text,
    .nav-title,
    .audi-logo {
      display: none;
    }

    .sidebar-content {
      gap: 32px;
    }

    .navigation {
      width: 100%;
    }

    .nav-item {
      justify-content: center;
      padding: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// AppSidebar.vue?d3afa898